/*
 * @Author: Gaho
 * @Date: 2024-02-28 13:55:22
 * @LastEditors: Gaho
 * @LastEditTime: 2024-10-07 14:56:15
 * @Description: 
 */
import { asyncEmit } from '@/utils/socket';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';
export const useCorgiWild = (rootPath = 'games') => {
    const EMIT_CORGIWILD_JOIN = (
        data: {},
        callback: any,
    ) => {
      
        socket.emit(`${rootPath}.corgiwild.join`, data, callback);
    };
    const EMIT_CORGIWILD_BET = (data: {}) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        return asyncEmit<{
            response,
            code?: number,
        }>( `${rootPath}.corgiwild.bet`, data);
    }
    return {
        EMIT_CORGIWILD_JOIN,
        EMIT_CORGIWILD_BET
    }
}